import { render, staticRenderFns } from "./hospital-selector.vue?vue&type=template&id=4fffbf77&scoped=true"
import script from "./hospital-selector.vue?vue&type=script&lang=js"
export * from "./hospital-selector.vue?vue&type=script&lang=js"
import style0 from "./hospital-selector.vue?vue&type=style&index=0&id=4fffbf77&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fffbf77",
  null
  
)

export default component.exports